const appConfig = {
    apiPrefix: process.env.REACT_APP_BASEURL,
    authenticatedEntryPath: '/dashboard',
    adminEntryPath: '/pin/initiate',
    initEntryPath: '/pin/initiate',
    authEntryPath: '/pin/authorize/list',
    unAuthenticatedEntryPath: '/sign-in',
    monitorEntryPath: '/monitor-dashboard',
    tourPath: '/',
}

export default appConfig